import React, { useRef, useEffect, useState } from "react";
import { message, Table, Image, Upload } from "antd";
import { YHDrawer } from "@/components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { getFormValidatorErrText, formatNum, getRandomStr, momentFormat } from "@/utils/utils";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { PlusOutlined, DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/lib/table";
import { ISaleSettlement } from "@/views/sales/salesTypes";
import moment from "moment";
import { salesService } from "@/views/sales/salesService";
import { useShipmentDetailModel } from "../shipmentDetailModel";
import { getBaseRequestUrl, getToken } from "@/utils/constants";
import { importPropsConfig } from "@/utils/importFile";
import { convertRes2Blob } from "@/utils/exportFile";
import { publicService } from "@/views/public/publicService";

//收汇
export function ReceiptSettleDrawer() {
    const { settleVisible: { visible, addedRow }, editFormVal, setSettleVisible, receiptSettle, getcurrencySymbol } = useShipmentDetailModel(({ settleVisible, editFormVal }) => [settleVisible, editFormVal]);
    const formRef = useRef<IYhFormRef>();
    const initDataSource: ISaleSettlement = {
        key: getRandomStr(),
        "settleTime": null,
        "settlePrice": 0,
        "ioFlag": 1,
        "settlementTime": null,
        "settlementPrice": 0,
        "exchangeRate": 0,
    };

    const [payDataSource, setPayDataSource] = useState<ISaleSettlement[]>([]);  //表格默认值

    useEffect(() => {
        if (visible) {
            formRef.current?.setFieldsValue({
                ...addedRow,
                createTime: momentFormat(addedRow?.createTime as string, "YYYY-MM-DD HH:mm:ss"),
                code: editFormVal.code,
                note: ""
            });
            loadData();
        }
    }, [visible])

    const onCancel = () => {
        setSettleVisible({ visible: false, addedRow: null });
    }

    //查询之前记录
    const loadData = async () => {
        let { retData } = await salesService.receiptPage({
            code: editFormVal.code,
            ioFlag: 1,
            "page": {
                "pageSize": 1000,
                "pageNum": 1
            }
        });
        if (retData.records && retData.records.length) {
            setPayDataSource(retData.records.map(item => ({
                ...item,
                key: item.id,
                settleTime: item.settleTime ? moment(item.settleTime) : null,
                settlementTime: item.settlementTime ? moment(item.settlementTime) : null,
            })))
            formRef.current?.setFieldsValue({
                ...addedRow,
                createTime: momentFormat(addedRow?.createTime as string, "YYYY-MM-DD HH:mm:ss"),
                settleTime: momentFormat(retData.records[0].createTime as string, "YYYY-MM-DD"),
                code: editFormVal.code,
                note: ""
            });
        } else {
            setPayDataSource([initDataSource]);
        }
    }

    //表单提交
    const onSubmit = async () => {

        // if (payDataSource.length >= 1) {
        //     message.warning("此单据已进行过结算");
        //     return;
        // }
        if (!payDataSource[0]?.settleTime) {
            message.warning("请选择付款日期");
            return;
        }
        if (!payDataSource[0]?.settlePrice) {
            message.warning("请输入付款金额");
            return;
        }
        formRef.current?.validateFields().then(res => {
            receiptSettle(payDataSource.map(item => ({
                ...item,
                key: undefined,
                code: editFormVal.code,
                settleTime: item.settleTime instanceof Object ? item.settleTime.format('YYYY-MM-DD') : null,
                settlementTime: item.settlementTime instanceof Object ? item.settlementTime.format('YYYY-MM-DD') : null,
            })))
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }
    //下载文件
    const downloadFile = async (fileId?: string, fileName?: string) => {
        if (!fileId) return message.warning("文件异常，无法下载查看");
        //pdf开网页预览
        if (fileId.indexOf(".pdf") >= 0) {
            window.open(`${getBaseRequestUrl()}/fsrv/fetch/${fileId}?Authorization=${getToken()}`)
            return;
        }
        try {
            let result = await publicService.downloadFile(fileId);
            convertRes2Blob(result, fileName);
        } catch (error) {
            console.error(error)
        }
    }

    const formConfig: IYhForm = {
        formRef,
        labelCol: { span: 6 },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "运出单号",
                fieldName: "code",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商名称",
                fieldName: "supplierName",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商编码",
                fieldName: "supplierCode",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结款日期",
                fieldName: "settleTime",
                style:"display:none",
                hidden:true,
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "应付金额",
                fieldName: "amount",
                prefix: getcurrencySymbol('edit'),
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 12,
                disable: true
            },
        ]
    };

    /**
     * 可编辑table
     */
    const columns = [
        {
            title: '付款日期',
            width: 160,
            dataIndex: 'settleTime',
            editable: true,
            editType: "datepicker",
            render: (text: any) => text instanceof Object ? text.format('YYYY-MM-DD') : text
        },
        {
            title: '付款金额',
            width: 160,
            dataIndex: 'settlePrice',
            editable: true,
            render: (text: any) => `￥${formatNum(text)}`
        },
        // {
        //     title: '结汇日期',
        //     width: 100,
        //     dataIndex: 'settlementTime',
        //     // editable: true,
        //     editType: "datepicker",
        //     render: (text: any) => text instanceof Object ? text.format('YYYY-MM-DD') : text
        // },
        // {
        //     title: '结汇金额',
        //     width: 100,
        //     dataIndex: 'settlementPrice',
        //     // editable: true,
        //     render: (text: any) => `￥${formatNum(text)}`
        // },
        // {
        //     title: '结汇汇率',
        //     width: 100,
        //     dataIndex: 'exchangeRate',
        //     // editable: true,
        // },
        {
            title: '附件',
            // width: 140,
            dataIndex: 'appendixList',
            align: "center",
            render: (fileList: any, record: any, index: number) => {
                return <>
                    {(fileList ?? []).map((file: any, index: number) => {
                        if ((file.md5.indexOf(".png") > -1 || file.md5.indexOf(".jpg") > -1 || file.md5.indexOf(".gif") > -1 || file.md5.indexOf(".jpeg") > -1)) {
                            return <div key={index}>
                                <Image src={`${getBaseRequestUrl()}/fsrv/fetch/${file.md5}?Authorization=${getToken()}`} style={{ width: "40px", height: "40px", marginRight: "10px" }} />
                                <span style={{ color: "blue", cursor: "pointer" }} onClick={() => downloadFile(file.md5, file.name)}>{file.name}</span>
                            </div>
                        } else {
                            return <div style={{ color: "blue", cursor: "pointer" }} onClick={() => downloadFile(file.md5, file.name)} key={index}>{file.name}</div>
                        }
                    })}
                    <div>
                        <Upload
                            showUploadList={false}
                            className="mr-10 ml-10"
                            {...importPropsConfig(`00`, (file: File & { response: { retData: string } }) => {
                                if (file) {
                                    let dataSource = [...payDataSource];
                                    const item = { ...record };
                                    dataSource.splice(index, 1, {
                                        ...item,
                                        appendixList: [...(item.appendixList ?? []), {
                                            name: file.name,
                                            md5: file?.response.retData,
                                        }]
                                    });
                                    setPayDataSource(dataSource);
                                }
                            })}
                        >
                            <UploadOutlined />
                        </Upload>
                    </div>
                </>
            }
        },
        {
            align: "center",
            title: '操作',
            width: 100,
            // render: (text: any, record: ISaleSettlement) => <div className="flex justify-around">
            //     <PlusOutlined
            //         style={{ fontSize: '18px', cursor: 'pointer' }}
            //         onClick={() => setPayDataSource(() => [...payDataSource, initDataSource])}
            //     />
            //     <DeleteOutlined
            //         style={{ fontSize: '18px', cursor: 'pointer' }}
            //         onClick={() => setPayDataSource(() => payDataSource.filter(item => item.key !== record.key))}
            //     />
            // </div>,
        }]

    const newPayColumns = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: ISaleSettlement, rowIndex: number) => ({
                colIndex: index,
                rowIndex,
                record,
                rules: col?.rules,
                options: col?.options,
                treeList: col?.treeList,
                editType: col?.editType,
                editable: col?.editable,
                onSelectChange: col?.onSelectChange,
                onTreeSelectChange: col?.onTreeSelectChange,
                onSelectFocus: col?.onSelectFocus,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: ISaleSettlement) => {
        let dataSource: ISaleSettlement[] = [...payDataSource];
        const index = dataSource.findIndex((item) => row.key === item.key);

        row.exchangeRate = +formatNum(row.exchangeRate);
        row.settlementPrice = +formatNum(row.settlementPrice);
        if (dataSource[index].settlePrice !== row.settlePrice) {
            //用户自己编辑不走计算公式
            row.settlePrice = +formatNum(row.settlePrice);
        } else {
            //收汇金额 = 结汇金额 * 结汇汇率
            row.settlePrice = +formatNum(row.exchangeRate * row.settlementPrice);
        }

        const item = dataSource[index];
        dataSource.splice(index, 1, { ...item, ...row });
        setPayDataSource(dataSource);
    }

    return (
        <YHDrawer
            {...{
                title: '加收费用结算',
                visible,
                onCancel,
                okText: "确认",
                width: 1000,
                onOk: onSubmit,
            }}
        >
            <YhForm {...formConfig} />
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newPayColumns as ColumnsType<ISaleSettlement>}
                dataSource={payDataSource}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
            <div className="table-bottom-total">合计:<span className="ml-135 statu-red">{`￥${formatNum(payDataSource.reduce((con, next) => { con += +(next.settlePrice ?? 0); return con }, 0))}`}</span></div>
        </YHDrawer>
    )
}
